<div class="app-bottom-bar">
  @if (getPageState() === pageState.dashboard) {
  <img class="logo" src="assets\images\plusmore_logo.svg" />

  } @else {
  <button (click)="back()" class="back-button">
    <mat-icon>arrow_back</mat-icon>
    <span class="back-text">Log in</span>
  </button>
  }

  <div class="button-containers">
    @if (getPageState() === pageState.dashboard) {
    <button
      class="login-btn bar-btn"
      mat-flat-button
      color="primary"
      (click)="login()"
    >
      Log in
    </button>
    } @if (getPageState() === pageState.dashboard) {
    <button
      class="join-btn bar-btn"
      [ngStyle]="{
        'background-color': '#000'
      }"
      mat-flat-button
      color="secondary"
      (click)="join()"
    >
      Join
    </button>
    }
  </div>
</div>
